/* mm-share-modal.js — robust: Event-Delegation für #mmShareTrigger */
(function () {
  const COLORS = {
    headerBG:  "#cfd8df",
    headerTX:  "#ffffff",
    border:    "#e9edf1",
    bodyTX:    "#29323a",
    inputBG:   "#f9fbfc",
    inputTX:   "#3f5666",
    iconBG:    "#eef3f7",
    iconST:    "#637283",
    backdrop:  "rgba(0,0,0,.45)",
    shadow:    "rgba(0,0,0,.18)",
    btnPriBG:  "#97aebb",
    btnPriTX:  "#ffffff",
    btnGhostBG:"#e8e6e2",
    btnGhostTX:"#3f5666",
    footerBG:  "#fafcfd"
  };

  const COPY_ICON_SRC = "https://cdn.shopify.com/s/files/1/0772/7058/1585/files/Kopieren_Symbol_2.svg?v=1762258002";

  function injectStyles() {
    if (document.getElementById("mmShareCSS")) return;
    const css = `
      .mmshare-modal{position:fixed;inset:0;z-index:10000;display:none;align-items:center;justify-content:center}
      .mmshare-modal[aria-hidden="false"]{display:flex}
      .mmshare-backdrop{position:absolute;inset:0;background:${COLORS.backdrop}}
      .mmshare-dialog{
        position:relative;background:#fff;border-radius:14px;box-shadow:0 10px 30px ${COLORS.shadow};
        width:min(760px,94vw);max-height:88vh;display:flex;flex-direction:column;overflow:hidden
      }
      .mmshare-header{
        position:relative;display:flex;align-items:center;justify-content:center;
        background:${COLORS.headerBG}; padding:clamp(14px,2.6vw,18px) clamp(16px,2.8vw,22px)
      }
      .mmshare-title{
        margin:0;color:${COLORS.headerTX};font-weight:700;line-height:1.2;
        max-width:calc(100% - 56px);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;
        font-size:clamp(18px, 4.6vw, 26px);
      }
      .mmshare-close{
        position:absolute;right:14px;top:8px;background:none;border:none;cursor:pointer;
        font-size:24px;color:#5a6c7a;line-height:1;border-radius:8px;transition:filter .15s ease, transform .15s ease;
      }
      .mmshare-body{padding:clamp(16px,3.4vw,22px) clamp(16px,3.4vw,22px) 8px; text-align:center; color:${COLORS.bodyTX}}
      .mmshare-lead{margin:0 0 12px 0; font-size:clamp(16px,3.8vw,18px); font-weight:700}
      .mmshare-urlrow{display:flex;align-items:center;gap:10px;margin:0 auto;max-width:min(640px,90vw)}
      .mmshare-input{
        flex:1;min-width:0;padding:12px 14px;border:1px solid ${COLORS.border};border-radius:10px;
        background:${COLORS.inputBG};color:${COLORS.inputTX};font-size:15px;transition:box-shadow .2s ease,border-color .2s ease
      }
      .mmshare-input:focus{outline:none;border-color:${COLORS.iconST};box-shadow:0 0 0 3px rgba(151,174,187,.35)}
      .mmshare-iconbtn{
        display:inline-flex;align-items:center;justify-content:center;width:44px;height:44px;border-radius:12px;
        border:1px solid ${COLORS.border}; background:${COLORS.iconBG}; cursor:pointer; flex:0 0 auto;
        transition:transform .15s ease, filter .15s ease, box-shadow .15s ease, background-color .15s ease;
      }
      .mmshare-iconbtn img{display:block;width:22px;height:22px}
      .mmshare-divider{margin:18px 0 0;height:1px;background:${COLORS.border}}
      .mmshare-footer{
        display:flex;flex-wrap:wrap;gap:12px;justify-content:center;padding:clamp(12px,2.8vw,16px);
        border-top:1px solid ${COLORS.border};background:${COLORS.footerBG}
      }
      .mmshare-btn{
        border-radius:12px;padding:11px 16px;font-size:16px;font-weight:700;cursor:pointer;
        border:1px solid transparent;display:inline-flex;align-items:center;justify-content:center;min-width:132px;
        transition:transform .15s ease, filter .15s ease, box-shadow .15s ease, background-color .15s ease, border-color .15s ease;
      }
      .mmshare-btn--primary{ background:${COLORS.btnPriBG}; color:${COLORS.btnPriTX}; border-color:${COLORS.btnPriBG} }
      .mmshare-btn--ghost{ background:${COLORS.btnGhostBG}; color:${COLORS.btnGhostTX}; border-color:${COLORS.btnGhostBG} }
      .mmshare-notice{margin:12px auto 0;max-width:min(640px,90vw);color:#5a6c7a;font-size:14px;text-align:center}
      .mmshare-pulse{ box-shadow:0 0 0 3px rgba(151,174,187,.35); transition: box-shadow .4s ease; }
      @media (hover:hover){
        .mmshare-btn--primary:hover{ filter:brightness(1.06); box-shadow:0 4px 14px rgba(151,174,187,.28) }
        .mmshare-btn--ghost:hover{ filter:brightness(1.02); box-shadow:0 4px 12px rgba(0,0,0,.08) }
        .mmshare-iconbtn:hover{ transform:translateY(-1px); box-shadow:0 4px 12px rgba(0,0,0,.10) }
        .mmshare-close:hover{ filter:brightness(0.9); transform:scale(1.04) }
      }
      .mmshare-btn:active, .mmshare-iconbtn:active{ transform:scale(.98) }
      @media (prefers-reduced-motion: reduce){
        .mmshare-btn, .mmshare-iconbtn, .mmshare-close { transition:none }
      }
      @media (max-width:460px){
        .mmshare-btn{ flex:1 1 140px; min-width:auto }
        .mmshare-urlrow{ gap:8px }
        .mmshare-iconbtn{ width:42px;height:42px }
      }
    `;
    const style = document.createElement("style");
    style.id = "mmShareCSS";
    style.textContent = css;
    document.head.appendChild(style);
  }

  function ensureModal() {
    if (document.getElementById("mmShareModal")) return;
    const modal = document.createElement("div");
    modal.id = "mmShareModal";
    modal.className = "mmshare-modal";
    modal.setAttribute("aria-hidden", "true");
    modal.innerHTML = `
      <div class="mmshare-backdrop" data-close></div>
      <div class="mmshare-dialog" role="dialog" aria-modal="true" aria-labelledby="mmShareTitle">
        <header class="mmshare-header">
          <h3 id="mmShareTitle" class="mmshare-title">Speichern und Teilen</h3>
          <button class="mmshare-close" type="button" aria-label="Schließen" data-close>×</button>
        </header>
        <main class="mmshare-body">
          <p class="mmshare-lead">Hier ist der Link zu deiner Memomap:</p>
          <div class="mmshare-urlrow">
            <input id="mmShareInput" class="mmshare-input" type="text" readonly />
            <button id="mmShareCopyIcon" class="mmshare-iconbtn" type="button" aria-label="URL kopieren" title="Kopieren">
              <img src="${COPY_ICON_SRC}" alt="" width="22" height="22" loading="eager" decoding="async">
            </button>
          </div>
          <p id="mmShareNotice" class="mmshare-notice" role="status" aria-live="polite" hidden>
            Deine Memomap-URL wurde in die Zwischenablage kopiert.
          </p>
          <div class="mmshare-divider" aria-hidden="true"></div>
        </main>
        <footer class="mmshare-footer">
          <button id="mmShareCopyBtn" class="mmshare-btn mmshare-btn--primary" type="button">Kopieren</button>
          <button class="mmshare-btn mmshare-btn--ghost" type="button" data-close>Schließen</button>
        </footer>
      </div>`;
    document.body.appendChild(modal);
  }

  function bindBehavior() {
    const modal   = document.getElementById("mmShareModal");
    const input   = document.getElementById("mmShareInput");
    const copyBtn = document.getElementById("mmShareCopyBtn");
    const copyIc  = document.getElementById("mmShareCopyIcon");
    const notice  = document.getElementById("mmShareNotice");
    let lastFocus = null;

    function fillUrl(){ input.value = window.location.href; }
    function openModal(){
      lastFocus = document.activeElement;
      fillUrl();
      modal.setAttribute("aria-hidden","false");
      setTimeout(()=>input.focus({preventScroll:true}),0);
    }
    function closeModal(){
      modal.setAttribute("aria-hidden","true");
      notice.hidden = true;
      input.classList.remove("mmshare-pulse");
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function showNotice(){
      notice.hidden = false;                         // bleibt sichtbar bis Close
      input.classList.add("mmshare-pulse");
      setTimeout(()=>input.classList.remove("mmshare-pulse"),400);
    }
    async function copyUrl(){
      const url = input.value;
      try{
        if (navigator.clipboard && window.isSecureContext){
          await navigator.clipboard.writeText(url);
        }else{
          input.select(); document.execCommand("copy");
        }
      }catch(e){ /* fallback handled above */ }
      showNotice();
    }

    // ✅ Event-Delegation: öffnet, egal wann #mmShareTrigger in den DOM kommt
    document.addEventListener("click", (e)=>{
      const btn = e.target.closest("#mmShareTrigger");
      if (btn) openModal();
      if (e.target.matches("[data-close]")) closeModal();
    });

    // ESC schließt
    document.addEventListener("keydown", (e)=>{
      if (e.key==="Escape" && modal.getAttribute("aria-hidden")==="false") closeModal();
    });

    copyBtn.addEventListener("click", copyUrl);
    copyIc.addEventListener("click", copyUrl);

    // optional programmatisch nutzbar
    window.mmShareOpen = openModal;
    window.mmShareClose = closeModal;

    // Falls SPA das Modal selbst neu in DOM mountet → erneut verdrahten
    const mo = new MutationObserver(()=>{ /* no-op; Delegation deckt Trigger ab */ });
    mo.observe(document.body, {subtree:true, childList:true});
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => { injectStyles(); ensureModal(); bindBehavior(); });
  } else {
    injectStyles(); ensureModal(); bindBehavior();
  }
})();
